var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge color-body u-select-none text-truncate",class:_vm.cssClass,attrs:{"title":_vm.description || _vm.text}},[_c('span',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }